<template>
  <b-form-group label="從應用庫套用" :label-for="inputId">
    <b-input-group>
      <b-form-select
        :id="inputId"
        v-model="selectedId"
        :disabled="isBusy"
        @change="applyApplication"
      >
        <b-form-select-option :value="null" disabled>請選擇應用</b-form-select-option>
        <b-form-select-option v-for="entry in applications" :key="entry.id" :value="entry.id">
          {{ entry.name }}
        </b-form-select-option>
      </b-form-select>
      <b-input-group-append>
        <b-button :disabled="isBusy" title="更新應用列表" aria-label="更新應用列表" @click="loadApplications">
          <b-icon icon="arrow-clockwise" aria-hidden="true" />
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <b-alert :show="Boolean(error)" variant="danger" class="mt-2">{{ error }}</b-alert>
  </b-form-group>
</template>

<script>
import axios from "axios";

export default {
  name: "QAApplicationSelect",
  props: {
    value: { type: String, default: "" },
    inputId: { type: String, required: true },
  },
  data() {
    return { applications: [], selectedId: null, isBusy: false, error: "" };
  },
  methods: {
    async loadApplications() {
      if (this.isBusy) return;
      this.isBusy = true;
      this.error = "";
      try {
        const base = process.env.VUE_APP_API_BASE;
        if (!base) throw new Error("尚未設定 API 網址");
        const response = await axios.get(`${base.replace(/\/+$/, "")}/api/qa/applications`);
        this.applications = response.data;
      } catch (error) {
        this.error = error.response?.data?.message || error.message || "讀取應用失敗";
      } finally {
        this.isBusy = false;
      }
    },
    async applyApplication(id) {
      if (this.isBusy) return;
      this.isBusy = true;
      this.error = "";
      try {
        const entry = this.applications.find((item) => item.id === id);
        const prompt = entry?.content?.prompt;
        if (typeof prompt !== "string" || !prompt.trim()) throw new Error("應用缺少有效 prompt");
        if (this.value && this.value !== prompt) {
          const confirmed = await this.$bvModal.msgBoxConfirm(
            "套用將取代目前欄位內容，是否繼續？",
            { title: "套用應用", okTitle: "套用", cancelTitle: "取消" },
          );
          if (!confirmed) return;
        }
        this.$emit("input", prompt);
      } catch (error) {
        this.error = error.message || "套用失敗";
      } finally {
        this.selectedId = null;
        this.isBusy = false;
      }
    },
  },
  mounted() { this.loadApplications(); },
};
</script>